module.exports = __webpack_public_path__ + "static/media/physics.be3668f7.png";